import React from 'react';

import LoadDocBtn from '../../../modules/load-doc-btn';
import TableDoc from '../../../modules/table-doc/table-doc';

import './order-realizations-docs.scss';

interface OrderRealizationsDocsProps {
  onSpecDownload: () => void;
}

const OrderRealizationsDocs: React.FC<OrderRealizationsDocsProps> = ({
  onSpecDownload,
}) => (
  <TableDoc
    docs={[
      <LoadDocBtn title="Спецификация!" onSpecDownload={onSpecDownload} />,
    ]}
    title="Документы реализации:"
  />
);

export default OrderRealizationsDocs;
